import type { BrandIconName } from '@shared/components/brand-icon/brand-icons';

/** Brand colour of each platform icon (mobile platform selector of Boost and Subscriptions) */
export const PLATFORM_BRAND_COLORS: Record<string, string> = {
	Instagram: '#E1306C',
	TikTok: '#111111',
	YouTube: '#FF0000',
	Telegram: '#229ED9',
	'Twitter / X': '#111111',
	Facebook: '#1877F2',
};

export function platformBrandColor(platformLabel: string): string {
	const exact = PLATFORM_BRAND_COLORS[platformLabel];
	if (exact) return exact;
	const key = (platformLabel || '').toLowerCase().replace(/[^a-z]/g, '');
	const loose = Object.keys(PLATFORM_BRAND_COLORS).find((k) => key.includes(k.toLowerCase().replace(/[^a-z]/g, '')));
	return loose ? PLATFORM_BRAND_COLORS[loose] : 'var(--gray-4)';
}

/** Brand logo of each platform (Boost / Subscriptions selector, product detail) */
const brandByPlatform: Record<string, BrandIconName> = {
	instagram: 'instagram',
	tiktok: 'tiktok',
	youtube: 'youtube',
	telegram: 'telegram',
	twitter: 'x',
	x: 'x',
	facebook: 'facebook',
};

/** Matches loosely ("Tik Tok", "YouTube Shorts", "Twitter / X"...); null = no logo (show a generic globe) */
export function platformBrandIcon(platformLabel: string): BrandIconName | null {
	const key = (platformLabel || '').toLowerCase().replace(/[^a-z]/g, '');
	const match = Object.keys(brandByPlatform).find((k) => (k.length > 1 ? key.includes(k) : key === k));
	return match ? brandByPlatform[match] : null;
}

/** Order of the platform selector (Boost, Subscriptions); platforms not listed go last, in their API order */
const PLATFORM_DISPLAY_ORDER: BrandIconName[] = ['instagram', 'tiktok', 'youtube', 'telegram'];

export function sortPlatformsForDisplay<T extends { label: string }>(platforms: T[]): T[] {
	const rank = (platform: T): number => {
		const brand = platformBrandIcon(platform.label);
		const index = brand ? PLATFORM_DISPLAY_ORDER.indexOf(brand) : -1;
		return index === -1 ? PLATFORM_DISPLAY_ORDER.length : index;
	};
	return [...platforms].sort((a, b) => rank(a) - rank(b));
}

/** Example link for the platform's link field (Boost and Subscriptions forms) */
export function platformLinkPlaceholder(platformLabel: string): string {
	switch (platformBrandIcon(platformLabel)) {
		case 'instagram':
			return 'https://instagram.com/tu_perfil';
		case 'tiktok':
			return 'https://tiktok.com/@tu_perfil';
		case 'youtube':
			return 'https://youtube.com/@tu_canal';
		case 'telegram':
			return 'https://t.me/tu_canal';
		case 'x':
			return 'https://x.com/tu_perfil';
		case 'facebook':
			return 'https://facebook.com/tu_pagina';
		default:
			return 'https://...';
	}
}
